module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp13_7042.2c430318.png";